(function () {
  const qs = (s, r) => (r || document).querySelector(s);
  const qsa = (s, r) => Array.from((r || document).querySelectorAll(s));

  const announce = qs("[data-zk-announce]");
  if (announce) {
    const slides = qsa(".announcement__slide", announce);
    let i = 0;
    const show = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((el, idx) => el.classList.toggle("is-on", idx === i));
    };
    const prev = qs("[data-zk-announce-prev]");
    const next = qs("[data-zk-announce-next]");
    if (prev) prev.addEventListener("click", () => show(i - 1));
    if (next) next.addEventListener("click", () => show(i + 1));
    if (slides.length > 1) setInterval(() => show(i + 1), 5000);
  }

  const press = qs("[data-zk-press]");
  if (press) {
    const slides = qsa(".testimonial", press);
    let i = 0;
    const show = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((el, idx) => el.classList.toggle("is-on", idx === i));
    };
    if (slides.length) {
      show(0);
      if (slides.length > 1) setInterval(() => show(i + 1), 4000);
    }
  }

  const drawer = qs("[data-zk-drawer]");
  const openBtn = qs("[data-zk-menu-open]");
  const closeBtn = qs("[data-zk-menu-close]");
  if (openBtn && drawer) {
    openBtn.addEventListener("click", () => { drawer.hidden = false; });
  }
  if (closeBtn && drawer) {
    closeBtn.addEventListener("click", () => { drawer.hidden = true; });
    drawer.addEventListener("click", (e) => {
      if (e.target === drawer) drawer.hidden = true;
    });
  }

  const gallery = qs("[data-zk-gallery]");
  if (gallery) {
    const main = qs("[data-zk-main]", gallery);
    qsa("[data-zk-thumb]", gallery).forEach((btn) => {
      btn.addEventListener("click", () => {
        qsa("[data-zk-thumb]", gallery).forEach((b) => b.classList.remove("is-on"));
        btn.classList.add("is-on");
        if (main) main.src = btn.getAttribute("data-src");
      });
    });
  }

  const form = qs("[data-zk-product-form]");
  if (form) {
    const select = qs("[data-zk-variant]", form);
    const priceEl = qs("[data-zk-price]");
    const compareEl = qs("[data-zk-compare]");
    const qty = qs("[data-zk-qty]", form);
    const packs = qsa("[data-zk-pack]", form);

    qsa("[data-zk-qty-btn]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const n = parseInt(qty.value || "1", 10) + Number(btn.getAttribute("data-zk-qty-btn"));
        qty.value = String(Math.max(1, n));
      });
    });

    packs.forEach((btn) => {
      btn.addEventListener("click", () => {
        packs.forEach((b) => b.classList.remove("is-on"));
        btn.classList.add("is-on");
        if (qty) qty.value = btn.getAttribute("data-qty") || "1";
        if (priceEl) priceEl.textContent = btn.getAttribute("data-price") || priceEl.textContent;
        if (compareEl) {
          const c = btn.getAttribute("data-compare");
          compareEl.hidden = !c;
          if (c) compareEl.textContent = c;
        }
      });
    });

    const parseMoney = (t) => Number(String(t || "").replace(/[^0-9.]/g, "")) || 0;
    const fmtMoney = (n) => "$" + n.toFixed(2);
    const syncPackPrices = (unit, unitCompare) => {
      packs.forEach((p) => {
        const q = Number(p.getAttribute("data-qty") || "1");
        const rate = q === 2 ? 0.9 : q === 3 ? 0.8 : 1;
        const price = unit * q * rate;
        const compare = unitCompare > 0 ? unitCompare * q : 0;
        p.setAttribute("data-price", fmtMoney(price));
        if (compare > price) p.setAttribute("data-compare", fmtMoney(compare));
        else p.removeAttribute("data-compare");
        const strong = p.querySelector(".zk-pack__price strong");
        const strike = p.querySelector(".zk-pack__price s");
        if (strong) strong.textContent = fmtMoney(price);
        if (strike) {
          strike.hidden = !(compare > price);
          if (compare > price) strike.textContent = fmtMoney(compare);
        }
      });
    };

    qsa("[data-zk-swatch]").forEach((btn) => {
      btn.addEventListener("click", () => {
        qsa("[data-zk-swatch]").forEach((b) => {
          b.classList.remove("is-on", "vpv2-card--selected");
        });
        btn.classList.add("is-on", "vpv2-card--selected");
        const id = btn.getAttribute("data-id");
        if (select) select.value = id;
        if (priceEl) priceEl.textContent = btn.getAttribute("data-price") || priceEl.textContent;
        if (compareEl) {
          const c = btn.getAttribute("data-compare");
          compareEl.hidden = !c;
          if (c) compareEl.textContent = c;
        }
        syncPackPrices(
          parseMoney(btn.getAttribute("data-price")),
          parseMoney(btn.getAttribute("data-compare"))
        );
        const onPack = packs.find((p) => p.classList.contains("is-on"));
        if (onPack && priceEl) priceEl.textContent = onPack.getAttribute("data-price") || priceEl.textContent;
        if (onPack && compareEl) {
          const c = onPack.getAttribute("data-compare");
          compareEl.hidden = !c;
          if (c) compareEl.textContent = c;
        }
        const img = btn.getAttribute("data-image");
        if (img && qs("[data-zk-main]")) qs("[data-zk-main]").src = img;
      });
    });
  }

  qsa("[data-zk-stories]").forEach((root) => {
    const track = qs("[data-zk-story-track]", root);
    const slides = qsa("[data-zk-story]", root);
    const prev = qs("[data-zk-story-prev]", root);
    const next = qs("[data-zk-story-next]", root);
    let i = 0;
    const names = qsa("[data-zk-story-names] button", root);
    const show = (n) => {
      if (!slides.length || !track) return;
      i = Math.max(0, Math.min(slides.length - 1, n));
      const gap = 20;
      const w = slides[0].getBoundingClientRect().width + gap;
      track.style.transform = "translateX(" + (-i * w) + "px)";
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      names.forEach((el, idx) => el.classList.toggle("is-on", idx === i));
    };
    if (prev) prev.addEventListener("click", () => show(i - 1));
    if (next) next.addEventListener("click", () => show(i + 1));
    names.forEach((el, idx) => el.addEventListener("click", () => show(idx)));
    window.addEventListener("resize", () => show(i));
    if (slides.length) show(0);
  });

  qsa("[data-zk-rev-peek]").forEach((root) => {
    const track = qs("[data-zk-peek-track]", root);
    const slides = qsa("[data-zk-peek-card]", root);
    const prev = qs("[data-zk-peek-prev]", root);
    const next = qs("[data-zk-peek-next]", root);
    let i = 0;
    const show = (n) => {
      if (!slides.length || !track) return;
      const gap = 16;
      const w = slides[0].getBoundingClientRect().width + gap;
      const vis = Math.max(1, Math.floor((root.getBoundingClientRect().width + gap) / w));
      const max = Math.max(0, slides.length - vis);
      i = Math.max(0, Math.min(max, n));
      track.style.transform = "translateX(" + (-i * w) + "px)";
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i >= max;
    };
    if (prev) prev.addEventListener("click", () => show(i - 1));
    if (next) next.addEventListener("click", () => show(i + 1));
    window.addEventListener("resize", () => show(i));
    if (slides.length) show(0);
  });

  const yotpo = qs("[data-zk-yotpo]");
  if (yotpo) {
    const items = qsa("[data-zk-rev]", yotpo);
    const q = qs("[data-zk-rev-q]", yotpo);
    const rating = qs("[data-zk-rev-rating]", yotpo);
    const pages = qs("[data-zk-rev-pages]", yotpo);
    const writeBtn = qs("[data-zk-write]", yotpo);
    const writePanel = qs("[data-zk-write-panel]", yotpo);
    const topics = qsa("[data-zk-topic]", yotpo);
    let page = 1;
    const size = 5;
    let topic = "";
    const filtered = () => {
      const term = ((q && q.value) || "").toLowerCase();
      const star = (rating && rating.value) || "";
      return items.filter((el) => {
        const text = el.textContent.toLowerCase();
        if (term && text.indexOf(term) === -1) return false;
        if (star && el.getAttribute("data-rating") !== star) return false;
        if (topic && text.indexOf(topic) === -1) return false;
        return true;
      });
    };
    const render = () => {
      const list = filtered();
      const max = Math.max(1, Math.ceil(list.length / size));
      if (page > max) page = max;
      items.forEach((el) => { el.hidden = true; });
      list.forEach((el, idx) => {
        el.hidden = !(idx >= (page - 1) * size && idx < page * size);
      });
      if (pages) {
        pages.innerHTML = "";
        for (let n = 1; n <= max; n++) {
          const b = document.createElement("button");
          b.type = "button";
          b.textContent = String(n);
          if (n === page) b.className = "is-on";
          b.addEventListener("click", () => { page = n; render(); });
          pages.appendChild(b);
        }
      }
    };
    if (q) q.addEventListener("input", () => { page = 1; render(); });
    if (rating) rating.addEventListener("change", () => { page = 1; render(); });
    topics.forEach((btn) => {
      btn.addEventListener("click", () => {
        const on = btn.classList.contains("is-on");
        topics.forEach((b) => b.classList.remove("is-on"));
        topic = on ? "" : (btn.textContent || "").toLowerCase();
        if (!on) btn.classList.add("is-on");
        page = 1;
        render();
      });
    });
    if (writeBtn && writePanel) {
      writeBtn.addEventListener("click", () => {
        writePanel.hidden = !writePanel.hidden;
      });
    }
    render();
  }
})();
